var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"table-simple",attrs:{"items":_vm.items,"hide-default-header":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('ItemRow',{attrs:{"item":item}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }